/* Pictures for TravelBuddy features */
import plan_itinerary_1 from '../assets/about/plan_itinerary_1.png';
import plan_itinerary_2 from '../assets/about/plan_itinerary_2.png';

import easy_collaboration_1 from '../assets/about/easy_collaboration_1.png';
import easy_collaboration_2 from '../assets/about/easy_collaboration_2.png';

import manage_spending_1 from '../assets/about/manage_spending_1.png';
import manage_spending_2 from '../assets/about/manage_spending_2.png';
import manage_spending_3 from '../assets/about/manage_spending_3.png';

export const ABOUT_DATA = [
    {
        id: 'plan',
        title: "Plan your itinerary",
        description: (
            <>
                To take the pain out of travel planning — so you can focus on what truly matters:
                <strong> making memories</strong> and <strong>enjoy your moments.</strong>
            </>
        ),
        theme: 'light',
        imageSrc: [
            plan_itinerary_1,
            plan_itinerary_2
        ]
    },
    {
        id: 'collab',
        title: "Easy collaboration",
        description: (
            <>
                Traveling with your friends?
                Not a problem. <strong>Manage plans together</strong>, split the bill at ease.
            </>
        ),
        theme: 'blue',
        imageSrc: [
            easy_collaboration_1,
            easy_collaboration_2
        ]
    },
    {
        id: 'spending',
        title: "Manage spending",
        description: (
            <>
                Track your spending and manage your budget. Look at your travel stats and <strong>control your own adventure.</strong>
            </>
        ),
        theme: 'dark',
        imageSrc: [
            manage_spending_1,
            manage_spending_2,
            manage_spending_3
        ]
    }
];